import React from 'react'
const DatoCard = (props) =>
    <div className={props.col ? `p-col-${props.col}` : "p-col"}>
        <div className="card-block">
            <p className="value">{props.valor} </p>
            <p className="label">{props.label}</p>
        </div>
    </div>;
export default DatoCard;